// extracted by mini-css-extract-plugin
export default {"job-recommendations__list":"job-recommendations__list_jcgtwtjM"};